module.exports = __webpack_public_path__ + "img/thumbnail_AfricanLeopard_f_erythristic.a55fd7ef.png";